export class TriggerReloadEvent {
    public readonly EVENT_NAME = 'clxReloadModules';

    constructor(viewRoot: HTMLElement) {
        document.dispatchEvent(
            new CustomEvent(this.EVENT_NAME, {
                detail: {
                    viewRoot: viewRoot,
                },
            }),
        );
    }
}

// Export fuer globales window object
if (typeof window !== 'undefined') {
    (window as any)['TriggerReloadEvent'] = TriggerReloadEvent;
}
